/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { CHANGE_LOCALE } from '../../constants/index.js';

/**
 * Settings locale reducer.
 * 
 * @param   {String} state 
 * @param   {String} action 
 * @returns {String}
 */
export default function ( state = '', action )
{
	switch( action.type )
	{
		case CHANGE_LOCALE:
			return action.payload;

		default:
			return state;
	}
}